<template>
    <div>
        <v-container fluid>
            <div v-if="isControlWaterArea" tyle="top:0px; margin: 0; padding: 0;">
      <v-row justify="center" style="background-color:white; top:0px;">
        <v-col cols="auto">
          <v-icon
          :color="iconColor"
          size="40"
        >
          {{ icon }}
        </v-icon>
        </v-col>
        <v-col cols="auto">
          <v-btn @click="waterArea(true)" style="background-color: darkgreen;">開放水域</v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn @click="waterArea(false)" style="background-color: red;">關閉水域</v-btn>
        </v-col>
      </v-row>
    </div>
        <div style="margin-top: 20px;">
        <v-tabs v-model="currentTab" align-tabs="center" grow @update:model-value="handleTabChange">
          <v-tab  class="custom-tab"
          v-for="tab in filteredTabs"  
          :key="tab.key"
          :value="tab.key"
          >
          {{ tab.name }}
        </v-tab>
        </v-tabs>
    </div>
        <!--v-window v-model="currentTab">
        <v-window-item v-for="tab in filteredTabs" :key="tab.key" :value="tab.key"-->
          <router-view />
        <!--/v-window-item>
      </v-window-->
        </v-container>
    </div>
</template>
  
<script setup>
import { ref , computed, onMounted, watch, onBeforeUnmount,  nextTick  } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth';
import { useStore } from '@/stores/mainStore';




const authStore =  useAuthStore();
const apiUrl = window.config.API_URL;
const wsUrl = window.config.WS_URL;
const router = useRouter();
const route = useRoute();
const currentTab = ref('tabCamera');
const store = useStore();

const isControlWaterArea = ref(false);

const tabs = ref([
      { name: '水域管理', key: 'tabCamera', route: 'LiveGridView3', props: { userId: authStore.userId }, external: false },
      { name: '戶外看板', key: 'tabDashboard', route: 'DashBoard', props: { areaId: store.areaId }, external: false },
      { name: '人流統計', key: 'tabHumain', route: 'HumanFlow3', props: { areaId: store.areaId }, external: true },
      { name: '戰情資料', key: 'tabBillboard', route: 'DeviceStatus', props: {}, external: false },
    ]);

const filteredTabs = computed(() => {
    /*
    if (authStore.areaId==2)
{
    console.log('tabs.value[2]',tabs.value[2].name);
        tabs.value[2].external=false;
        
}
        */
    return tabs.value.filter(tab => !tab.external);
});

const getAreaId=(property) =>{

  const match = property.match(/areaId:(\d+)/); 
  return match ? parseInt(match[1], 10) : null; 
};


const handleTabChange = (newTabKey) => {
    console.log('tabs',tabs.value);
 console.log('newTabKey',newTabKey);
  const newTab = tabs.value.find(tab => tab.key === newTabKey);
  console.log('newTab',newTab);
  if (!newTab) return;
  const index = tabs.value.findIndex(tab => tab.key === newTabKey);

  console.log('Switched to tab:', newTab);
  const paramNames=getParamNames(index);
            let paramValue=null;
            if (paramNames.length > 0)
                paramValue=getParamValue(index,paramNames[0]);
            console.log('params',paramValue);
            const params = {
                [paramNames[0]]: paramValue 
            };
            console.log('params',params);
            router.push({ 
                name: newTab.route, 
                params: params 
            });
  /*
  console.log('areaId', newTab.props.areaId);
  
  router.push({ 
        name: newTab.route, 
        params: { areaId: store.areaId } 
  });
  */
  
}


const onItemActivate = (activeItems) => {
      console.log('Active Items:', activeItems); 
      //console.log('params:', activeItems[0].title+','+activeItems[0].path+','+ activeItems[0].props);
      if (activeItems && activeItems.length > 0) {
        console.log('activeItems[0].property',activeItems[0].property);
        if (activeItems[0].property!=null)
        {
            console.log('activeItems[0].property.areaId:',activeItems[0].property);
            var aId=getAreaId(activeItems[0].property) ;
            console.log('aId:', aId);
            console.log('tabs',tabs);

        
            store.setAreaId(aId); 
            navigateTo(activeItems[0].path, activeItems[0].property); 
            navigateTo('Billboard', activeItems[0].property); 
            //currentTab.value=activeItems[0].path;
            const matchingTab = tabs.value.find(tab => tab.route === activeItems[0].path);
            if (matchingTab) {
                currentTab.value = matchingTab.key;
            }
            if (aId==2)
            {
                tabs.value[2].external=false;
            }
            else
            {
                tabs.value[2].external=true;
            }
        }
        else
        {
            navigateTo(activeItems[0].path, null); 
        }
      }
      return;
      alert(activeItems.length);
      if (activeItems && activeItems.length > 0) {
    // Update areaId based on selected tree item
    areaId.value = activeItems[0].props?.areaId || 1
    alert(areaId.value);
    // Navigate to the first tab with the selected areaId
    router.push({ 
      name: 'LiveViewGrid', 
      params: { areaId: areaId.value } 
    })
  }
     
};

const navigateTo = (path, props) => {
    console.log('=======================');
    console.log('current path',route.path);
  console.log('path',path);
  console.log('areaId',props);
  if (props!= null)
  {
      //var areaId=2
      //console.log(props);
      if (path) {
        console.log('store areaId:',store.areaId);
        router.push({  name:path , params: { areaId:store.areaId} });
      }
    }
  
  else
  {
    if (path) {
        router.push( path  );
      }
  }
}

const setCurrentTabFromRoute = () => {
    const currentRoute = router.currentRoute.value;
    console.log('Current route name:', currentRoute.name);
    
    const matchingTab = tabs.value.find(tab => tab.route === currentRoute.name);
    if (matchingTab) {
        currentTab.value = matchingTab.key;
        console.log('Set current tab to:', currentTab.value);
    } else {
        currentTab.value = filteredTabs.value[0]?.key || null;
    }
};

const getParamValue = (tabIndex, paramName) => {
  const tab = tabs.value[tabIndex]; 
  return tab?.props[paramName]; 
};

const getParamNames = (tabIndex) => {
  const tab = tabs.value[tabIndex]; 
  return tab ? Object.keys(tab.props) : []; 
};


/*



const icon = computed(() => {
  console.log('currentState.value',currentState.value);
  return states[currentState.value];
});

const iconColor = computed(() => {
  console.log('iconColor',currentState.value);
  switch (currentState.value) {
        case '0': 
          return 'green';
        case '1': 
          return 'red';
        case '99': 
          return 'gray';
        default:
          return 'grey';
      }
});
*/

let socket=null;
const states= ['mdi-swim', 'mdi-alert-box', 'mdi-lightbulb-question-outline'];
const currentState=ref(0);


const icon = ref(states[currentState.value]); // Reactive ref to hold the current icon
const iconColor = ref('grey'); // Reactive ref to hold the current icon color




watch(currentState, (newValue) => {
  icon.value = states[newValue]; 
  console.log('watch icon.value',icon.value);
  switch (newValue) {
    case 0:
      iconColor.value = 'green';
      break;
    case 1:
      iconColor.value = 'red';
      break;
    case 2:
      iconColor.value = 'grey';
      break;
    default:
      iconColor.value = 'grey';
  }
  console.log('watch iconColor.value',iconColor.value);
});


const connectToWebSocket= async ()=> {
  const serverUrl = wsUrl; //"wss://localhost:7262/ws"; 
  console.log('serverUrl',serverUrl);
  const reconnectInterval = 5000; 

  const createWebSocket = () => {
    socket = new WebSocket(serverUrl);

    socket.onopen = () => {
      console.log("WebSocket connection established");
    };

    socket.onmessage = async(event) => {
      console.log("Message from server:", event.data);
      //this.messages.push(event.data); 
      

      const newValue = parseInt(event.data.trim());
      if (currentState.value !== newValue) {
        
        currentState.value = newValue;
        await nextTick(); 
        console.log('onMessage after update:', currentState.value);
      }
      
      
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    socket.onclose = (error) => {
      console.log("WebSocket connection closed. Code:", event.code, "Reason:", event.reason);
      
        console.log("Attempting to reconnect...");
        setTimeout(() => {
          createWebSocket();
        }, reconnectInterval);
      
      
    };
  };

  createWebSocket();
};


onMounted(()=>{
    //alert('home onMounted');
    /*
    console.log('tabs[0]',tabs.value[0]);
    console.log('tabs[0]',tabs.value[0].route);
  currentTab.value=tabs.value[0].route;
  */
 /*
  setCurrentTabFromRoute();
    
    // If no route is active, navigate to the first tab
    if (!router.currentRoute.value.name || router.currentRoute.value.name === 'Home') {
        const firstTab = filteredTabs.value[0];
        if (firstTab) {
            console.log('Navigating to first tab:', firstTab.route);
            router.push({ 
                name: firstTab.route, 
                params: { areaId: store.areaId } 
            });
        }
    }
    */
    console.log('isWaterArea', isControlWaterArea.value);
    
    const currentRoute = router.currentRoute.value;
    console.log('Current route at mount:', currentRoute.name);
    
    // Find the tab that matches the current route
    const matchingTab = tabs.value.find(tab => tab.route === currentRoute.name);
    if (matchingTab) {
        currentTab.value = matchingTab.key;
        console.log('Set current tab to:', currentTab.value);
    } else {
        // If no matching route, set to the first available tab and navigate to it
        const firstTab = filteredTabs.value[0];
        console.log('firstTab',firstTab);
        if (firstTab) {
            currentTab.value = firstTab.key;

            const paramNames=getParamNames(0);
            let paramValue=null;
            if (paramNames.length > 0)
                paramValue=getParamValue(0,paramNames[0]);
            console.log('params',paramValue);
            const params = {
                [paramNames[0]]: paramValue 
            };
            console.log('params',params);
            router.push({ 
                name: firstTab.route, 
                params: params 
            });
        }
    }
});

watch(() => {
  
     isControlWaterArea.value=authStore.waterAreaControl;
    tabs.value[2].external=!authStore.showFlow;
    if (isControlWaterArea.value)
    {
      connectToWebSocket();
    }
}
);




</script>

<style>

.custom-tab {
  font-size: 24px; 
}

</style>